export const parseAttemptLogLines = (logs: string | null | undefined): Record<string, unknown>[] => {
  if (!logs) {
    return [];
  }

  const lines = logs
    .trim()
    .split('\n')
    .filter((line) => line.trim());
  const parsedLogs: Record<string, unknown>[] = [];
  for (const line of lines) {
    try {
      parsedLogs.push(JSON.parse(line));
    } catch (error) {
      console.warn('Failed to parse log line:', line, error);
    }
  }
  return parsedLogs;
};
